// Generated file - do not change manually!
/**
 * Defines input types
 */
export var InputType;
(function (InputType) {
    /**
     * Used for input fields that must contain an e-mail address.
     */
    InputType["Email"] = "Email";
    /**
     * Defines a numeric input field.
     */
    InputType["Number"] = "Number";
    /**
     * Defines a password field.
     */
    InputType["Password"] = "Password";
    /**
     * Used for input fields that should contain a telephone number.
     */
    InputType["Tel"] = "Tel";
    /**
     * Defines a one-line text input field:
     */
    InputType["Text"] = "Text";
    /**
     * Used for input fields that should contain a URL address.
     */
    InputType["URL"] = "URL";
})(InputType || (InputType = {}));
